import React, { Component, ReactElement } from 'react';

import _get from 'lodash.get';

import { ButtonTheme, ModalType } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';
import { classNames, isFunction } from '@philips-emr/tws-utils';

import { ReactComponent as SearchIcon } from '../../../resources/assets/components/DLS_Search.svg';
import Button from '../button/button';
import Input from '../input/input';

import LocatorModal from './locator-modal';

import './locator-input.css';

export interface LocatorInputProps {
  className: string;
  displayProp: string;
  enabled: boolean;
  fragment: string;
  inputEnabled?: boolean;
  modalType: ModalType;
  onBlur?: (event: FocusEvent) => void;
  onChange?: (event: ChangeEvent<string>) => void;
  onFocus?: (event: FocusEvent) => void;
  onSubmit?: (event: Record<string, Value>) => void;
  placeholder: string;
  readOnly?: boolean;
  value?: Value;
}

interface LocatorInputState {
  open: boolean;
}

class LocatorInput extends Component<LocatorInputProps, LocatorInputState> {

  state: LocatorInputState = {
    open: false,
  };

  openModal = (): void => {
    const { readOnly } = this.props;

    if (readOnly) {
      return;
    }

    this.setState({ open: true });
  };

  onChange = ({ value }: ChangeEvent<string>): void => {
    const { displayProp, onChange } = this.props;

    if (isFunction(onChange)) {
      onChange(new ChangeEvent<string>({ entry: displayProp, oldValue: _get(value, displayProp), value }));
    }
  };

  onCloseModal = (): void => {
    this.setState({ open: false });
  };

  onSubmit = (event: Record<string, Value>): void => {
    const { onSubmit } = this.props;

    this.setState({ open: false });

    if (isFunction(onSubmit)) {
      onSubmit(event);
    }
  };

  renderModal(): ReactElement {
    const { fragment, modalType } = this.props;

    const locatorModal = {
      fragment,
      modalType,
      onClose: this.onCloseModal,
      onSubmit: this.onSubmit,
    };

    return (
      <LocatorModal {...locatorModal} />
    );
  }

  renderButton(): ReactElement | null {
    const { enabled, readOnly } = this.props;

    if (readOnly) {
      return null;
    }

    return (
      <Button
        enabled={enabled}
        icon={<SearchIcon className="c-locator-search__icon" />}
        onClick={this.openModal}
        theme={ButtonTheme.SECONDARY}
        value=""
      />
    );
  }

  renderInput(): ReactElement {
    const { displayProp, enabled, inputEnabled, onBlur, onFocus, placeholder, readOnly, value } = this.props;

    const inputProps = {
      autoComplete: 'off',
      autoCorrect: false,
      className: 'c-locator-input__input',
      enabled: inputEnabled && enabled,
      onBlur,
      onChange: this.onChange,
      onFocus,
      placeholder: !readOnly ? placeholder : '',
      readOnly,
      value: _get(value, displayProp),
    };

    return (
      <div className="c-locator-input__input-wrapper" >
        <Input {...inputProps} />
        {this.renderButton()}
      </div>
    );
  }

  render(): ReactElement {
    const { className, readOnly } = this.props;
    const { open } = this.state;

    const wrapperClassName = classNames({
      [className]: true,
      'c-locator-input': true,
    });

    return (
      <div className={wrapperClassName}>
        {this.renderInput()}
        {open && !readOnly && this.renderModal()}
      </div>
    );
  }
}

export default LocatorInput;
